module.exports = __webpack_public_path__ + "static/assets/bf047233ba300252e95be43aeef838c5.png";